<template>
    <div class="headline">
        <h1>{{ title }}</h1>
    </div>
</template>

<script>

    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';


    export default {
        props:{
            title: {
                default:"",
                type:String
            }
        },
        name: "Headline",
        mixins:[common,storeMapper]
    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .headline {
        margin-bottom: 1.5rem;
        overflow: hidden;
    }

    .headline h1 {
        float: left;
        font-size: 1rem;
        line-height: 1.5rem;
    }

    .headline a {
        float: right;
    }


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Headline.vue